/** Módulo de motivos de reprogramación — catálogo de códigos CMMS */

import { createCrudMethods } from '../base/crudMethods';

/**
 * Crea métodos CRUD para motivos de reprogramación
 *
 * @param {Object} deps - Dependencias inyectadas
 * @param {Function} deps.authenticatedRequest - Función de request autenticado
 * @returns {Object} Métodos CRUD generados
 */
export function createMotivosReprogramacionModule({ authenticatedRequest }) {
  return {
    ...createCrudMethods(
      {
        endpoint: '/api/motivos-reprogramacion',
        entityName: 'motivoReprogramacion',
        entityNamePlural: 'motivosReprogramacion',
        methods: { getById: false, lista: true }
      },
      { authenticatedRequest }
    )
  };
}
